import React from 'react';
import { Search, Filter } from 'lucide-react';
import EssaySampleCard from './EssaySampleCard';

const EssaySamples = ({
  searchTerm,
  setSearchTerm,
  selectedCategory,
  setSelectedCategory,
  categories,
  filteredSamples,
  autofillFromSample,
  generateFlashCardsFromEssay,
  startQuizFromEssay
}) => {
  return (
    <div className="space-y-6">
      {/* Hero Section with Unsplash Background */}
      <div
        className="relative rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-purple-600 text-white p-8"
        style={{
          backgroundImage: 'linear-gradient(rgba(59, 130, 246, 0.9), rgba(147, 51, 234, 0.9)), url(https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="relative z-10">
          <h2 className="text-3xl font-bold mb-3">Professional Writing Templates</h2>
          <p className="text-blue-100 text-lg">
            Explore our comprehensive collection of letter and email templates for every occasion
          </p>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white p-6 rounded-xl shadow-sm border">
        <div className="flex flex-col lg:flex-row gap-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">Search Templates</label>
            <div className="relative">
              <Search className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
              <input
                type="text"
                placeholder="Search by title or category..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 transition-colors"
              />
            </div>
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">Filter by Category</label>
            <div className="relative">
              <Filter className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="pl-10 w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 transition-colors"
              >
                {categories.map(category => (
                  <option key={category} value={category}>
                    {category === 'all' ? 'All Categories' : category}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Results count */}
        <div className="mt-4 text-sm text-gray-600">
          Showing {filteredSamples.length} template{filteredSamples.length !== 1 ? 's' : ''}
          {selectedCategory !== 'all' && ` in "${selectedCategory}"`}
          {searchTerm && ` matching "${searchTerm}"`}
        </div>
      </div>

      {/* Sample Cards */}
      {filteredSamples.length > 0 ? (
        <div className="grid gap-6 lg:grid-cols-2 xl:grid-cols-3">
          {filteredSamples.map(sample => (
            <EssaySampleCard
              key={sample.id}
              sample={sample}
              autofillFromSample={autofillFromSample}
              generateFlashCardsFromEssay={generateFlashCardsFromEssay}
              startQuizFromEssay={startQuizFromEssay}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <div className="text-gray-400 mb-4">
            <Search className="w-16 h-16 mx-auto" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">No templates found</h3>
          <p className="text-gray-500">
            Try adjusting your search terms or category filter to find what you're looking for.
          </p>
        </div>
      )}
    </div>
  );
};

export default EssaySamples;
